/**
 * PUBLIC-ONLY ROUTE WRAPPER
 *
 * For routes like /login, /signup that should redirect authenticated
 * users to their dashboard. Prevents flash of login page when
 * already authenticated.
 *
 * Uses canonical access state — no custom auth checks.
 */

import { Navigate } from "react-router";
import { useAccessState } from "@/hooks/useAccessState";
import { getDefaultRouteForRole } from "@/lib/auth/routing";
import { AppShellLoading } from "./AppShellLoading";

interface PublicOnlyRouteProps {
  children: React.ReactNode;
}

export function PublicOnlyRoute({ children }: PublicOnlyRouteProps) {
  const { isFullyResolved, isAuthenticated, role } = useAccessState();

  // Wait for full resolution — never flash login page then redirect
  if (!isFullyResolved) {
    return <AppShellLoading />;
  }

  // Authenticated users get redirected to their dashboard
  if (isAuthenticated) {
    const target = getDefaultRouteForRole(role);
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
}
